import { createSelector } from '@reduxjs/toolkit';
import StructureAPI from '../StructureAPI';
import { RootState } from '../../store.model';

// Pattern: createApiSelector
const getStructureSelector = createSelector(
  (arg: string | undefined) => arg,
  (workspaceId) => StructureAPI.endpoints.getStructureV2.select(workspaceId)
);
export const getStructure = (
  state: RootState,
  args: { workspaceId: string | undefined }
) => getStructureSelector(args.workspaceId)(state);

export const structureInfo = createSelector(
  [getStructure],
  (structure) => structure
);

export const isLoadingStructure = createSelector(
  [getStructure],
  (structure) => structure.isLoading
);

export const structureStatus = createSelector(
  [getStructure],
  (structure) => structure.status
);

export const structureData = createSelector(
  [getStructure],
  (structure) => structure.data
);

export const structureError = createSelector(
  [getStructure],
  (structure) => structure.error
);
